import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Checkbox,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import theme from "../../configs/theme";

export default function InventarioTableUI({
  data,
  headerData,
  onRowToggle,
  showCheckbox,
  selectedRows,
  checkboxLabel,
  priceIncrease,
}) {
  const calculatePricePercentage = (price, percentage) => {
    const newPrice = price * (1 + percentage / 100);
    return Math.ceil(newPrice / 100) * 100;
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: showCheckbox ? "64.26%" : "60.2%",
        marginTop: 2,
        maxHeight: "70vh",
        overflowY: "auto",
        "&::-webkit-scrollbar-track": {
          background: theme.tableColors.header,
        },
      }}
    >
      <Table stickyHeader>
        <TableHead
          sx={{
            "& .MuiTableCell-root": {
              backgroundColor: theme.tableColors.header,
              fontSize: {
                md: theme.fontSizes.medium,
                sm: theme.fontSizes.small,
              },
              fontWeight: "bold",
              color: theme.colors.black,
              padding: "12px",
              borderBottom: "1px solid #ffffff",
            },
          }}
        >
          <TableRow>
            {headerData.map((item) => (
              <TableCell key={item}>{item}</TableCell>
            ))}
            {showCheckbox && (
              <TableCell
                sx={{
                  width: "6%",
                  "&.MuiTableCell-root": {
                    align: "center",
                    pt: 0,
                    pb: 0,
                  },
                }}
              >
                {checkboxLabel === "Editar" ? <EditIcon /> : <DeleteIcon />}
              </TableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody
          sx={{
            backgroundColor: theme.tableColors.body,
            "& .MuiTableCell-root": {
              fontSize: {
                md: theme.fontSizes.small,
                sm: theme.fontSizes.xsmall,
              },
              color: theme.colors.black,
              padding: "10px",
            },
          }}
        >
          {data.map((row, index) => (
            <TableRow
              key={row.id}
              sx={{
                "&:hover": {
                  backgroundColor: theme.hoverColors.body,
                },
              }}
            >
              <TableCell>{index + 1}</TableCell>
              <TableCell
                sx={{
                  maxWidth: 80,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {row.name}
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 80,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {row.product_type?.type}
              </TableCell>
              <TableCell>
                {selectedRows.includes(row.id) &&
                !isNaN(parseFloat(priceIncrease))
                  ? `${row.price} → ${calculatePricePercentage(
                      row.price,
                      parseFloat(priceIncrease)
                    )}`
                  : row.price}
              </TableCell>
              <TableCell>
                {row.quantity_reference === 1
                ? "Por Unidad"
                : row.quantity_reference >= 1000
                  ? `Por ${(row.quantity_reference / 1000).toFixed(1)} kg`
                  : `Por ${row.quantity_reference} gr`}
              </TableCell>
              {/* Checkboxes si esta seleccionado la opcion de borrado o actualizar */}
              {showCheckbox && (
                <TableCell align="center">
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={() => onRowToggle(row.id)}
                    size="small"
                    sx={{
                      padding: 0,
                    }}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
